import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import AssignedProductsSummary from "./AssignedProductsSummary";
import MeasurementCard from "./MeasurementCard";
import { GroupedAssignment, ProductOption } from "../measurementTypes";
import { StageMeasurementDraft } from "../stageMeasurements";

type MeasurementsSidebarBodyProps = {
  measurements: StageMeasurementDraft[];
  selectedFeatureId: string | null;
  products: ProductOption[];
  groupedAssignments: GroupedAssignment[];
  applyError: string | null;
  onSelectFeature: (featureId: string) => void;
  onUpdateProduct: (featureId: string, product: ProductOption | null) => void;
  onToggleScreenshot: (featureId: string, checked: boolean) => void;
};

export default function MeasurementsSidebarBody({
  measurements,
  selectedFeatureId,
  products,
  groupedAssignments,
  applyError,
  onSelectFeature,
  onUpdateProduct,
  onToggleScreenshot,
}: MeasurementsSidebarBodyProps) {
  return (
    <MDBox px="20px" py="16px" sx={{ overflowY: "auto", flex: 1 }}>
      <MDBox display="flex" flexDirection="column" gap="8px">
        {measurements.map((measurement) => (
          <MeasurementCard
            key={measurement.featureId}
            measurement={measurement}
            isSelected={measurement.featureId === selectedFeatureId}
            products={products}
            onSelect={onSelectFeature}
            onUpdateProduct={onUpdateProduct}
            onToggleScreenshot={onToggleScreenshot}
          />
        ))}

        {!measurements.length && (
          <UiTypography uiVariant="body-sm" sx={{ color: "#667085" }}>
            Draw at least one area or line measurement on the map to begin assigning products.
          </UiTypography>
        )}
      </MDBox>

      <AssignedProductsSummary assignments={groupedAssignments} />

      {applyError && (
        <UiTypography uiVariant="body-sm" sx={{ color: "#D92D20", mt: "16px" }}>
          {applyError}
        </UiTypography>
      )}
    </MDBox>
  );
}
